import {
  isProjectTypeIn,
  projectTypeDiscipline,
} from "../../../../../constants/projectTypes";

export { documentAbbreviations } from "../../../../../pages/client/AllEquipments/CommonFeatures/DCSTab/Table/Dashboard/docListAPI";

export const wbsLabel = (wbs) =>
  wbs?.name || wbs?.projectName || "Untitled WBS";

export const docLabel = (doc) =>
  doc?.documentNumber ||
  doc?.description ||
  doc?.documentName ||
  doc?.uid ||
  "Untitled document";

// The numbered "Doc No" identifier (e.g. "COR-001") - distinct from the
// longer composite DUID (documentNumber) - see DOCUMENT_REGISTER_GUIDE.md.
export const docNumberLabel = (doc) =>
  doc?.documentName || doc?.uid || doc?.docNumber || docLabel(doc);

export const matches = (label, query) => label.toLowerCase().includes(query);

// A 2D drawing matches a tree search on its number / name / title.
export const matchesDrawing = (drawing, query) => {
  if (!drawing || !query) return false;
  return [
    drawing?.drawingNumber,
    drawing?.dwgNumber,
    drawing?.name,
    drawing?.title,
    drawing?.rev,
    drawing?.revision,
  ]
    .filter((value) => value != null && String(value) !== "")
    .some((value) => matches(String(value), query));
};

// 2D drawings ride on the WBS record itself (wbs.drawings); the separately
// fetched drawingsByWbs register is only a fallback for WBS payloads that
// don't embed them.
export const drawingsOf = (wbs, drawingsByWbs) => {
  if (Array.isArray(wbs?.drawings)) return wbs.drawings;
  const fetched = drawingsByWbs?.[wbs?.id];
  return Array.isArray(fetched) ? fetched : [];
};

export const hasDrawings = (wbs, drawingsByWbs) =>
  drawingsOf(wbs, drawingsByWbs).length > 0;

export const hasDrawingMatch = (wbs, query, drawingsByWbs) =>
  drawingsOf(wbs, drawingsByWbs).some((drawing) =>
    matchesDrawing(drawing, query),
  );

export const isPvWbs = (wbs) => projectTypeDiscipline(wbs?.type) === "pv";

// Piping/Structural projects carry their own Estimation data directly on
// the project's revisions (each revision's `data.estimationTable`) - already
// embedded in the same /project/plant/:plantId/:clientName response
// the plant WBS fetch returns, unlike PV which needs a separate /PV/all call.
export const isPipOrStrucWbs = (wbs) =>
  isProjectTypeIn(wbs?.type, ["pip", "struc"]);

export const drawingNumberOf = (drawing) =>
  drawing?.drawingNumber ??
  drawing?.dwgNumber ??
  drawing?.name ??
  drawing?.title ??
  "Untitled drawing";

export const drawingRevOf = (drawing) =>
  drawing?.rev ?? drawing?.revision ?? "";

export const drawingLabel = (drawing) =>
  `${drawingNumberOf(drawing)} - (Rev (${drawingRevOf(drawing)}))`;
